import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// Runtime detection - works in both localhost and production
const API = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8001/api' 
  : '/api';

function ChangePasswordPage() {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem('token');
  const axiosConfig = {
    headers: { 'Authorization': `Bearer ${token}` }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      alert('Yeni şifreler eşleşmiyor!');
      return;
    }

    if (newPassword.length < 6) {
      alert('Şifre en az 6 karakter olmalıdır!');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/auth/change-password?old_password=${oldPassword}&new_password=${newPassword}`, {}, axiosConfig);
      alert('Şifreniz başarıyla değiştirildi!');
      navigate('/');
    } catch (err) {
      alert(err.response?.data?.detail || 'Şifre değiştirilemedi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="card">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-2xl font-bold">Şifre Değiştir</h1>
            <button onClick={() => navigate('/')} className="text-gray-400 hover:text-white">
              ✕ Kapat
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-300 mb-2">Mevcut Şifre</label>
              <input
                type="password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
                placeholder="Mevcut şifrenizi girin"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Yeni Şifre</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                placeholder="Yeni şifrenizi girin"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Yeni Şifre (Tekrar)</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="Yeni şifrenizi tekrar girin"
              />
            </div>

            <div className="bg-yellow-900/30 border border-yellow-700 rounded p-3 text-sm">
              <strong>Güvenlik İpuçları:</strong>
              <ul className="list-disc list-inside mt-2 space-y-1 text-xs">
                <li>En az 8 karakter kullanın</li>
                <li>Büyük ve küçük harf karıştırın</li>
                <li>Rakam ve özel karakter ekleyin</li>
                <li>Kolay tahmin edilebilir şifreler kullanmayın</li>
              </ul>
            </div>

            <div className="flex gap-3">
              <button
                type="submit"
                disabled={loading}
                className="flex-1 btn-primary"
              >
                {loading ? 'Değiştiriliyor...' : 'Şifre Değiştir'}
              </button>
              <button
                type="button"
                onClick={() => navigate('/')}
                className="flex-1 btn-secondary"
              >
                İptal
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordPage;
